module.exports = __webpack_public_path__ + "static/img/vip-group-en.3640d6d5.png";